import adminMeta from '../adminMeta.js'
import { checkRole } from '@/utils/utils.js'

export default [
  {
    path: '/admin/trade/active',
    name: 'admin-trade-active',
    meta: {
      ...adminMeta,
      layout: 'main-sidebar-layout',
    },
    component: () => import('@/views/Admin/Trade/AdminTradeActiveView.vue'),
    async beforeEnter(to, from, next) {
      try {
        const candidate = await checkRole('admin')
        if (candidate) {
          return next()
        } else {
          return next({ name: 'login' })
        }
      } catch (e) {}
    },
  },
  {
    path: '/admin/trade/archive',
    name: 'admin-trade-archive',
    meta: {
      ...adminMeta,
      layout: 'main-sidebar-layout',
    },
    component: () => import('@/views/Admin/Trade/AdminTradeArchiveView.vue'),
    async beforeEnter(to, from, next) {
      try {
        const candidate = await checkRole('admin')
        if (candidate) {
          return next()
        } else {
          return next({ name: 'login' })
        }
      } catch (e) {}
    },
  },
  {
    path: '/admin/trade/delete',
    name: 'admin-trade-delete',
    meta: {
      ...adminMeta,
      layout: 'main-sidebar-layout',
    },
    component: () => import('@/views/Admin/Trade/AdminTradeDeleteView.vue'),
    async beforeEnter(to, from, next) {
      try {
        const candidate = await checkRole('admin')
        if (candidate) {
          return next()
        } else {
          return next({ name: 'login' })
        }
      } catch (e) {}
    },
  },
]
